module.exports = __webpack_public_path__ + "static/media/larazon.a40847b1.png";